$(document).ready(function () {
  // $("#DFEC .add-to-cart--calculator").on("click", function (e) {
  //   console.log("Clicked!");
  //   $(".buy-buttons--calculator .buy-buttons-1 .product-form form .product-form__submit").trigger("click");
  //   $(".buy-buttons--calculator .buy-buttons-2 .product-form .form .product-form__submit").trigger("click");
  //   $(".buy-buttons--calculator .buy-buttons-3 .product-form .form .product-form__submit").trigger("click");
  // });

  $(".addonProductAddToCart").on("click", function (e) {
    e.preventDefault();
    let id = parseInt($(this).attr("data-id"));
    console.log("working");
    console.log(id);
    addItemToCart(id);
  });


});

function addItemToCart(variant_id) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variant_id,
      },
      dataType: "json",
      success: function (data) {
        console.log(data.id);
        // document.dispatchEvent(new CustomEvent("cart:refresh"));

          // setTimeout(() => {
          //   var cart = new theme.CartDrawer();
          //   cart.init();
          //   cart.open();
          //   console.log("cart");
          // }, 200);

          //  location.reload();

        // $(".drawer").addClass("active");
      },
    });
  }

  